import { Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { GlobalService } from '@app/services/global.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-loading',
  styleUrls: ['./loading.component.scss'],
  templateUrl: './loading.component.html',
  imports: [],
})
export class LoadingComponent {
  globalService = inject(GlobalService);

  @Input() busy = false;
  @Input() text = 'loading';

  @Input() cancelable = false;
  @Input() cancelButtonText = 'CANCEL';
  @Output() cancelLoading = new EventEmitter<void>();

  get updateServiceUrl() {
    return `${window.location.protocol}//${window.location.hostname}:${environment.updateServicePort}`;
  }
}
